import React, { useEffect } from 'react'
import { setPaymentMethod } from 'lib/core/data/quote/paymentMethod'
import { useDispatch } from 'react-redux'
import { useCart } from 'lib/core/hooks'
import { PAYMENT_METHOD } from 'lib/core/resources/constants'
import { localStorage } from 'lib/core/services/localStorage'
import { useHistory } from 'react-router-dom'
import { PaypalExpressState } from 'lib/core/hooks/usePaypalExpress'
import { FormattedMessage } from 'react-intl'

type queryStringParam = string | undefined

export const ProcessPaypalExpress = () => {
  const history = useHistory()
  const { cartId } = useCart()
  const dispatch = useDispatch()
  useEffect(() => {
    if (!cartId) return

    const queryStringObj: Record<string, string> = {}
    const query = window.location.href.split('?')[1]
    const vars = query.split('&')
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=')
      queryStringObj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1])
    }

    const [url] = window.location.hash.slice(1).split('/?')
    const { token, PayerID: payerId } = queryStringObj

    dispatch(setPaymentMethod({
      cartId,
      code: PAYMENT_METHOD.PAYPAL_EXPRESS
    }))

    const data: PaypalExpressState = {
      token: token as queryStringParam ?? null,
      payerId: payerId as queryStringParam ?? null
    }

    localStorage.set('paypalExpressState', data)
    history.replace(`/${decodeURIComponent(url)}`)
  }, [cartId, dispatch, history])

  return <p><FormattedMessage id='app.loading' /></p>
}
